;(function (tests) {
  "use strict"

  function amplitudeNwayTestIdentify() {
    if (tests) {
      /**
       * This is for mapping ABC variants from the nway test
       * to a value that is redeable on amplitude
       */
      const nwayTests = {
        frame_ads: {
          A: "control",
          B: "show_ads",
        },
      }
      const identity = new amplitude.Identify()

      Object.keys(tests).forEach((testName) => {
        if (nwayTests[testName]) {
          const testAssignment = tests[testName]
          const value = nwayTests[testName][testAssignment]

          identity.set(testName, value)
        }
      })
      amplitude.getInstance().identify(identity)
    }
  }
  if (typeof amplitude !== "undefined") {
    amplitudeNwayTestIdentify()
  }
})(window.nway_tests)
